module.exports = __webpack_public_path__ + "static/media/notification.ad08ff67.mp3";